import styled from 'styled-components';
import { MainPage } from 'Container';
import { asRem } from 'utils';

export default styled(MainPage)`
  .content {
    max-width: ${asRem(800)};
    margin: 0 auto;
  }

  .animation {
    width: 100%;
    height: 100%;
    max-width: 840px;
    margin: ${asRem(40)} auto;
  }
`;
